export default __webpack_public_path__ + "static/media/DNo.8-0.464e4d37.jpg";